const AUTH_TOKEN_STORAGE_KEY = 'cnk_auth_token';
const REFRESH_TOKEN_STORAGE_KEY = 'cnk_refresh_token';
const LEGACY_AUTH_TOKEN_STORAGE_KEY = 'token';

let inMemoryAuthToken = null;
let authTokenHydrated = false;

const canUseBrowserStorage = () => typeof window !== 'undefined';

const normalizeToken = (value) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

const readTokenFromStorage = () => {
  if (!canUseBrowserStorage()) {
    return null;
  }

  const sessionToken = normalizeToken(
    window.sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY)
      || window.sessionStorage.getItem(LEGACY_AUTH_TOKEN_STORAGE_KEY),
  );
  if (sessionToken) {
    window.sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, sessionToken);
    window.sessionStorage.removeItem(LEGACY_AUTH_TOKEN_STORAGE_KEY);
    window.localStorage.removeItem(LEGACY_AUTH_TOKEN_STORAGE_KEY);
    return sessionToken;
  }

  const legacyToken = normalizeToken(window.localStorage.getItem(LEGACY_AUTH_TOKEN_STORAGE_KEY));
  if (legacyToken) {
    window.sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, legacyToken);
    window.localStorage.removeItem(LEGACY_AUTH_TOKEN_STORAGE_KEY);
    return legacyToken;
  }

  return null;
};

export const getAuthToken = () => {
  if (!authTokenHydrated || (!inMemoryAuthToken && canUseBrowserStorage())) {
    inMemoryAuthToken = readTokenFromStorage();
    authTokenHydrated = true;
  }
  return inMemoryAuthToken;
};

export const persistAuthToken = (token) => {
  const normalizedToken = normalizeToken(token);
  inMemoryAuthToken = normalizedToken;
  authTokenHydrated = true;

  if (!canUseBrowserStorage()) {
    return normalizedToken;
  }

  if (normalizedToken) {
    window.sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, normalizedToken);
  } else {
    window.sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  }
  window.sessionStorage.removeItem(LEGACY_AUTH_TOKEN_STORAGE_KEY);
  window.localStorage.removeItem(LEGACY_AUTH_TOKEN_STORAGE_KEY);

  return normalizedToken;
};

export const getRefreshToken = () => {
  if (!canUseBrowserStorage()) return null;
  return normalizeToken(window.sessionStorage.getItem(REFRESH_TOKEN_STORAGE_KEY));
};

export const persistAuthSession = ({ token, access_token: accessToken, refresh_token: refreshToken }) => {
  const persisted = persistAuthToken(token || accessToken);
  if (canUseBrowserStorage() && normalizeToken(refreshToken)) {
    window.sessionStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, normalizeToken(refreshToken));
  }
  return persisted;
};

export const clearAuthSession = () => {
  inMemoryAuthToken = null;
  authTokenHydrated = true;

  if (!canUseBrowserStorage()) {
    return;
  }

  window.sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  window.sessionStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  window.sessionStorage.removeItem(LEGACY_AUTH_TOKEN_STORAGE_KEY);
  window.localStorage.removeItem(LEGACY_AUTH_TOKEN_STORAGE_KEY);
};

export const buildAuthHeaders = (tokenOverride = null) => {
  const token = normalizeToken(tokenOverride) || getAuthToken();
  if (!token) {
    return {};
  }
  return { Authorization: `Bearer ${token}` };
};
